const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessengerRafiki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -9.1,
    y: 151.55,
    width: 300.73,
    height: 160.97,
    transform: "translate(373.3 90.77) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.59,
    y: 141.75,
    width: 20.05,
    height: 3.74,
    transform: "translate(367.24 -80) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.59,
    y: 323.86,
    width: 20.05,
    height: 3.74,
    transform: "translate(549.35 102.11) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.49,
    y: 183.66,
    width: 300.73,
    height: 96.74,
    transform: "translate(505.89 -41.82) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.04,
    y: 196.21,
    width: 275.63,
    height: 71.64,
    transform: "translate(505.89 -41.82) rotate(90)",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: "1.0458500000000002px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.34,
    y: 229.55,
    width: 300.73,
    height: 4.97,
    transform: "translate(556.74 -92.68) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.24,
    y: 92.13,
    width: 140.05,
    height: 290.27,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.82,146.25a9.35,9.35,0,0,0-9.35-9.28,9.25,9.25,0,0,0-3.5.68,11.31,11.31,0,0,0-21.2,2.5,9.73,9.73,0,0,0,.63,19.44h31a6.9,6.9,0,0,0,2.45-13.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.43,122.65a7.87,7.87,0,0,1,10.84-7.24,9.53,9.53,0,0,1,17.87,2.11,8.2,8.2,0,0,1-.53,16.38H162.5a5.82,5.82,0,0,1-2.07-11.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.24,
    y: 325.73,
    width: 140.05,
    height: 56.67,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.62,286.93c-10.39,9.09-33,38.8-50.06,15.45s-47.32-30.91-47.32-30.91v54.26H211.29V284S186.28,271.47,168.62,286.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,218.93a4.07,4.07,0,1,1-4.07-4.07A4.07,4.07,0,0,1,316,218.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.79,218.93a6.69,6.69,0,1,1-6.69-6.7A6.7,6.7,0,0,1,312.79,218.93Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.75,275.5C417.67,231.09,419,159,418,134.94a4.39,4.39,0,0,0-.54-2.09h0c-.89-1.45-2.14,0-2.11,2.49.19,11.94.4,41.78-.74,93.27-.57,25.63-1.39,43.18-.83,46.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.67,183.56c4.58-12,13.95-20.58,23.5-20.53,3.74,0-11.41,14-17.71,29.41-4.89,12-10.41,32.13-12.29,43.32C416.39,212.22,417.08,195.59,421.67,183.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.08,183.44c-4.54-13.22-15-23.4-26.36-24.55-4.45-.45,12.48,16.15,18.8,33.16,4.91,13.22,10,35.11,11.33,47.11C416.18,214.25,416.61,196.67,412.08,183.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.67,202.88c4.58-12,13.95-20.58,23.5-20.54,3.74,0-11.41,14-17.71,29.42-4.89,12-10.41,32.13-12.29,43.31C416.39,231.54,417.08,214.91,421.67,202.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.08,203.84c-4.54-13.23-15-23.4-26.36-24.55-4.45-.45,12.48,16.15,18.8,33.16,4.91,13.21,10,35.1,11.33,47.11C416.18,234.65,416.61,217.07,412.08,203.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.84,138.13c3-8.94,9.43-15.91,16.15-16.86,2.64-.38-7.76,11-11.91,22.5a194.92,194.92,0,0,0-7.85,31.74C417.65,158.83,417.83,147.06,420.84,138.13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.86,141.9c-3.19-9.32-10.58-16.49-18.57-17.3-3.14-.31,8.8,11.38,13.25,23.37a176.13,176.13,0,0,1,8,33.2C417.76,163.62,418.06,151.23,414.86,141.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.87,149.72c3.88-10.18,11.82-17.43,19.9-17.39,3.17,0-9.66,11.85-15,24.91a213.48,213.48,0,0,0-10.41,36.68C417.4,174,418,159.9,421.87,149.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,155.14c-3.84-11.2-12.72-19.81-22.32-20.79-3.77-.38,10.57,13.68,15.93,28.08a212.26,212.26,0,0,1,9.59,39.89C417.46,181.23,417.82,166.34,414,155.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.13,163.85c4.19-11,12.75-18.8,21.47-18.76,3.42,0-10.42,12.78-16.17,26.87a228.8,228.8,0,0,0-11.23,39.57C417.31,190,417.94,174.84,422.13,163.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.38,169.87c-4.27-12.44-14.12-22-24.78-23.08-4.19-.43,11.73,15.18,17.68,31.17,4.61,12.43,9.34,33,10.65,44.29C417.24,198.83,417.64,182.3,413.38,169.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.05,268.93l.68,10.91c.07,2.44,1.13,4.35,2.41,4.35h17c1.28,0,2.34-1.91,2.42-4.35l.67-10.91c.08-2.65-1-4.89-2.41-4.89H405.47C404.08,264,403,266.28,403.05,268.93Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,271.24h25.25c.37,0,.68-.53.73-1.24l.6-10.39c0-.82-.29-1.54-.73-1.54H401.43c-.43,0-.77.72-.72,1.54l.6,10.39C401.35,270.71,401.66,271.24,402,271.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.22,
    y: 284.19,
    width: 18.11,
    height: 98.2,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.9 382.4 468.33 382.4 468.33 363.61 457.21 363.61 462.9 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.47,
    y: 284.19,
    width: 18.11,
    height: 98.2,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.84,
    y: 284.19,
    width: 107.49,
    height: 86.67,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.27 382.4 360.84 382.4 360.84 363.61 371.96 363.61 366.27 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.05,
    y: 290.29,
    width: 99.07,
    height: 34.68,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.59,301.07H401.22c-5.29,0-10.36-4.28-14-11.83H445.6C442,296.79,436.89,301.07,431.59,301.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.05,
    y: 330.58,
    width: 99.07,
    height: 34.68,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.59,341.36H401.22c-5.29,0-10.36-4.28-14-11.83H445.6C442,337.08,436.89,341.36,431.59,341.36Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.85,125.61c-.12.59-.53,1-.92.93s-.6-.62-.48-1.21.53-1,.92-.93S338,125,337.85,125.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.37,126.63a21.82,21.82,0,0,1-3.85,4.49,3.47,3.47,0,0,0,2.72,1.1Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.68,122.77a.36.36,0,0,0,.26-.6,3.51,3.51,0,0,0-3-1.17.36.36,0,1,0,.12.7h0a2.81,2.81,0,0,1,2.37,1A.35.35,0,0,0,340.68,122.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.28,136.38c-1.07,5.48-1.72,13.06,2.11,16.72,0,0-1.5,5.55-11.67,5.55-11.19,0-5.38-4.87-5.38-4.87,4.65-1.45,4.61-6.74,3.54-11Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.41,154.75s1.25-3.86,2.52-4.53,14.81-2.41,16.68-.87-2.34,6.48-2.34,6.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,409c-1,0-1.88-.13-2.15-.57a.66.66,0,0,1,.08-.77.91.91,0,0,1,.59-.41c1.27-.34,3.77,1.15,3.87,1.21a.18.18,0,0,1,.08.18.2.2,0,0,1-.16.15A13.83,13.83,0,0,1,333,409ZM332,407.53a1.22,1.22,0,0,0-.34,0,.55.55,0,0,0-.37.25c-.14.22-.11.32-.07.39.31.48,2.2.49,3.61.3A7.39,7.39,0,0,0,332,407.53Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.3,408.77h-.07c-.87-.41-2.53-2-2.32-2.87,0-.2.2-.45.7-.5a1.22,1.22,0,0,1,.95.3c.89.79.93,2.8.93,2.89a.19.19,0,0,1-.19.19Zm-1.58-3h-.11c-.32,0-.35.16-.36.2-.12.51,1,1.78,1.87,2.34a3.88,3.88,0,0,0-.8-2.31A.87.87,0,0,0,333.72,405.74Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.54 408.59 336.06 408.59 336.73 391.26 344.21 391.26 343.54 408.59",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.18,407.73h8.17a.59.59,0,0,1,.6.51l.93,6.65a1.19,1.19,0,0,1-1.18,1.33c-2.95-.05-7.19-.22-10.9-.22-4.33,0-4.88.24-10,.24-3.07,0-3.67-3.11-2.36-3.39,6-1.28,7.53-1.42,12.85-4.54A3.69,3.69,0,0,1,336.18,407.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.71,172.72a2.1,2.1,0,0,1,1.09,1.76l.05,1.67a2.05,2.05,0,0,1-1.26,2l-3.36,1.41a4.6,4.6,0,0,1-3,.18L304,178.53a2.5,2.5,0,0,1-1.57-2.19l-.14-2.37a2.51,2.51,0,0,1,2.62-2.66l2,.09A11.58,11.58,0,0,1,314.71,172.72Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.93,165.44A53.21,53.21,0,0,1,361.3,172a47.88,47.88,0,0,1-5.67,5.81,71.4,71.4,0,0,1-12.94,8.65l-.41.22a4.42,4.42,0,0,1-3,.46c-2.24-.44-4.47-1-6.7-1.51s-4.43-1.18-6.63-1.87-4.38-1.43-6.54-2.29c-1.08-.43-2.14-.9-3.21-1.38s-2.08-1-3.26-1.62a2.82,2.82,0,0,1,1.93-5.23l.27.06,3.05.62c1.06.21,2.13.38,3.2.56q3.21.54,6.45,1c2.15.32,4.32.57,6.49.85l6.51.73-3.43.68a81.09,81.09,0,0,0,10.71-8.25,51.21,51.21,0,0,0,4.36-4.73,62.66,62.66,0,0,0,3.83-5.29l0,0a5.67,5.67,0,0,1,9.6,6Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.46,160.63c-1.53,8.08-2.49,24.69,2,57.57h40A234.33,234.33,0,0,1,368.1,163,10.07,10.07,0,0,0,359,151.6c-.86-.07-1.73-.13-2.59-.17a146.32,146.32,0,0,0-17,0c-1.88.17-3.72.44-5.36.73A10.61,10.61,0,0,0,325.46,160.63Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.73 391.27 336.38 400.2 343.87 400.2 344.22 391.27 336.73 391.27",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.84,128.37c-1.92,7.18-2.69,11.47-7.11,14.46-6.66,4.48-15-.67-15.22-8.27-.23-6.85,2.95-17.43,10.65-18.88A10.14,10.14,0,0,1,357.84,128.37Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.34,129.72c-1.28-2.83.44-7.49,2.55-8.74-1.56-1.26-3.16-2.49-2.55-5.48s6.49-6.72,10-4.11,17.17-1.33,12.95,8.22c9.44,3.56-2.5,18.15-8.72,21.88S342.08,137.83,339.34,129.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,119.72s3.72-.89,4.11-6.11C368.17,118.44,366.39,120.83,361,119.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.64,128.57a8.42,8.42,0,0,1-2.9,4.54c-1.91,1.5-3.4.12-3.32-2.09.07-2,1.15-5.16,3.28-5.81S345.14,126.4,344.64,128.57Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.37 381.15 408.74 384.35 399.78 369.11 406.41 365.91 415.37 381.15",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,384.76c-.72.65-1.48,1.17-2,1-.17,0-.39-.19-.46-.62a1,1,0,0,1,.16-.71c.72-1.11,3.57-1.68,3.69-1.7a.15.15,0,0,1,.17.08.2.2,0,0,1,0,.21A13.63,13.63,0,0,1,405,384.76Zm-1.77-.35a1.38,1.38,0,0,0-.23.26.65.65,0,0,0-.11.43c0,.26.15.32.22.34.55.15,2-1.12,2.87-2.21A7.55,7.55,0,0,0,403.25,384.41Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.56,383.08l-.06,0c-.92.28-3.23.2-3.65-.57-.1-.18-.14-.47.19-.84a1.18,1.18,0,0,1,.91-.41c1.18,0,2.57,1.44,2.63,1.51a.2.2,0,0,1,0,.17A.17.17,0,0,1,406.56,383.08Zm-3.21-1.19-.07.08c-.22.24-.16.35-.14.39.25.46,1.93.65,2.95.48a3.81,3.81,0,0,0-2.14-1.18A.93.93,0,0,0,403.35,381.89Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.51,381.72l6.05-5.5a.61.61,0,0,1,.79,0l5.16,4.3a1.19,1.19,0,0,1,0,1.78c-2.21,1.94-5.47,4.67-8.22,7.16-3.2,2.91-3.45,3.45-7.21,6.87-2.28,2.06-4.81.17-4-.92,3.55-5,4.63-6.12,6.46-12A3.66,3.66,0,0,1,406.51,381.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.78 369.12 404.4 376.97 411.03 373.77 406.42 365.91 399.78 369.12",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.62,218.2s12.52,57.5,17.31,78.84c5.25,23.37,40.54,78.18,40.54,78.18l12.18-6.37s-22.65-46.18-31.42-73c-3.9-25-12.78-77.63-12.78-77.63Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.62,218.2s12.52,57.5,17.31,78.84c5.25,23.37,40.54,78.18,40.54,78.18l12.18-6.37s-22.65-46.18-31.42-73c-3.9-25-12.78-77.63-12.78-77.63Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.14,372.84c-.05,0,2.72,4.46,2.72,4.46l14.25-7.51-1.46-4.5Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,244.85c9.42,1.25,10.51,34.46,10.34,53.94-.13-.62-.27-1.2-.39-1.76-2.61-11.65-7.53-34.1-11.46-52.07A3.29,3.29,0,0,1,349,244.85Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.42,218.2s-1.81,56-1.18,78.79c.65,23.71,7,101.48,7,101.48H346s1.68-76.35,3.08-99.67c1.51-25.42,4.7-80.6,4.7-80.6Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.42,218.2s-1.81,56-1.18,78.79c.65,23.71,7,101.48,7,101.48H346s1.68-76.35,3.08-99.67c1.51-25.42,4.7-80.6,4.7-80.6Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.71,393.42c-.06,0,.28,5.26.28,5.26h15.43l.8-4.69Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,184.92a2.07,2.07,0,0,1,1.57,1.35l.55,1.57a2.06,2.06,0,0,1-.61,2.26l-2.78,2.36a4.68,4.68,0,0,1-2.84,1.09l-4.31.12a2.5,2.5,0,0,1-2.16-1.61l-.85-2.22a2.51,2.51,0,0,1,1.7-3.32l1.91-.51A11.54,11.54,0,0,1,291,184.92Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,163.23c-.83,3.05-1.75,6.09-2.67,9.13s-1.92,6.06-3,9.07-2.18,6-3.43,9c-.62,1.51-1.27,3-2,4.55a43.67,43.67,0,0,1-2.58,4.74l-.23.36a4.59,4.59,0,0,1-4.58,2.07c-1.26-.2-2.52-.37-3.77-.61s-2.49-.49-3.73-.82-2.46-.64-3.68-1.05-2.42-.82-3.61-1.28a50.74,50.74,0,0,1-6.91-3.38,37.72,37.72,0,0,1-3.23-2.15c-.53-.38-1-.79-1.55-1.21-.26-.21-.51-.42-.76-.66s-.47-.44-.81-.78a2.79,2.79,0,0,1,3.19-4.5l.46.23,1.3.66c.48.23,1,.47,1.47.68,1,.44,2,.81,3.06,1.18a60.55,60.55,0,0,0,6.35,1.82c2.15.48,4.33.86,6.52,1.14,1.08.16,2.2.22,3.29.35l3.31.21-4.8,2.42a34.23,34.23,0,0,0,1.64-3.67c.53-1.35,1.06-2.75,1.56-4.17,1-2.85,1.93-5.78,2.86-8.72l2.72-8.88,2.7-8.93a5.67,5.67,0,0,1,10.91,3.1Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.17,160.08c3,9.88-10,23.42-10,23.42l-14.23-6.76s1.6-11.75,7.62-18.8C333,149.25,339.89,152.57,342.17,160.08Z",
    style: {
      fill: "#3DD064"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.4,219.69c5.85,5.48,6.91,10.42,6.13,17s-9.56,8.55-9.56,8.55l.76-24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.16 408.01 168.17 407.89 167.67 389.27 159.66 389.39 160.16 408.01",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.26,407l-8.75.14a.62.62,0,0,0-.62.56l-.76,7.15a1.3,1.3,0,0,0,1.32,1.41c3.15-.1,7.69-.36,11.66-.42,4.64-.07,4.18.12,9.63,0,3.28-.05,3.81-3.39,2.4-3.67-6.42-1.28-7.07-1.35-12.87-4.61A4.07,4.07,0,0,0,168.26,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.77,161.73c3.23,4,6.67,8.18,10.1,12.14s7,7.87,10.64,11.37l.68.64.35.33.17.16,0,0-.06-.05-.14-.1a2.79,2.79,0,0,0-1-.39.67.67,0,0,0-.35,0s.28,0,.64,0a10.84,10.84,0,0,0,1.33-.36,41.85,41.85,0,0,0,6.45-3.16c4.42-2.56,8.92-5.57,13.29-8.54l4.07,4.45A93,93,0,0,1,210.9,190a43.37,43.37,0,0,1-7.61,5,20.28,20.28,0,0,1-2.5,1,12.13,12.13,0,0,1-3.36.65,8.78,8.78,0,0,1-2.36-.2,7.9,7.9,0,0,1-2.81-1.2l-.34-.24-.24-.18-.21-.17-.43-.34-.85-.68c-2.26-1.82-4.38-3.73-6.41-5.68s-4-4-5.9-6a162.84,162.84,0,0,1-10.78-12.83Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.81,165.11c-.6,7.74,18.29,23.73,18.29,23.73L194,175.45a93.94,93.94,0,0,0-14-15.12C172.22,154,163.46,156.62,162.81,165.11Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.66,171.32c3.34.56,11.07,9.4,11.36,13.45l-3.92,4.07a116.36,116.36,0,0,1-12.65-12.69C170,173.44,171.9,171,173.66,171.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.66,180.07l9.19-.37-1.92-8.94s-7.11-.66-9.12,4.94Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.63,174.64,233.32,171a1.83,1.83,0,0,0-1.78-.84l-4.61.57,1.92,8.94,5.9-2.35A1.84,1.84,0,0,0,235.63,174.64Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.67 389.27 167.93 398.87 159.91 399 159.66 389.4 167.67 389.27",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.73,157A100.76,100.76,0,0,0,134,159.78a2.76,2.76,0,0,0-2,3.29c6.73,29.73,3.93,60.5,4.45,66.87l42.94-.69c3.06-36.65-.46-59.65-2.18-68.05A5.33,5.33,0,0,0,172.73,157Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.17,157.25l-2,.48a.32.32,0,0,0-.14.54c7.45,6.85,37.4,42.81,38.27,73.06h2.59c-.88-30.7-31.6-68-38.48-74A.28.28,0,0,0,143.17,157.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.08,173.62c.66,2.95-.73,16.41-3.94,19.73-.26-4.31-.65-8.81-1.21-13.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.81,137c1.36,5.77,2.9,16.08-1.06,20.29,3.31,2.92,7.61,6.61,14.59,6.34s5.67-5,3.74-7.37c-6.61-1.07-6.69-5.92-5.72-10.55Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.52,140.59l6.83,5.15a19.58,19.58,0,0,0-.44,3.27c-2.51-.18-6-2.66-6.41-5.25A8.79,8.79,0,0,1,151.52,140.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.86,128.27c1,7.89,1.2,12.57,5.47,16.34,6.43,5.67,16,1.31,17.36-6.74,1.24-7.25-.61-18.94-8.59-21.52A11,11,0,0,0,144.86,128.27Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.53,116.42A4,4,0,0,1,172,119a.74.74,0,0,1-1,.84c-4.26-1.82-14.48-1.07-14.48-1.07S165.33,115,169.53,116.42Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.53,116.42A4,4,0,0,1,172,119a.74.74,0,0,1-1,.84c-4.26-1.82-14.48-1.07-14.48-1.07S165.33,115,169.53,116.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.75,135.33l3.5-.66s3-6.83-.5-8.95c4-4.18,18.21-1.3,15.87-6.16-1.92-4-10.88-6.38-18-3.76s-6.27,6-6.27,6-5.58,4.22-1.23,9.19C140.17,133.13,144.34,136.33,146.75,135.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.39,131a.65.65,0,0,0,1-.06c1.44-1.83,6.26-7.51,12.26-9.9a35.44,35.44,0,0,1,11.31-2.63.65.65,0,0,0,.54-1,24.46,24.46,0,0,0-3.48-5.2c-1.58-1.42-12.92-2.06-16.23.12-2.23,1.48-8.52,7.8-8.77,10.86C135.83,125.34,137.14,128.58,139.39,131Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.39,131a.65.65,0,0,0,1-.06c1.44-1.83,6.26-7.51,12.26-9.9a35.44,35.44,0,0,1,11.31-2.63.65.65,0,0,0,.54-1,24.46,24.46,0,0,0-3.48-5.2c-1.58-1.42-12.92-2.06-16.23.12-2.23,1.48-8.52,7.8-8.77,10.86C135.83,125.34,137.14,128.58,139.39,131Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.14,124.2a25.38,25.38,0,0,1,13-2.66,2.69,2.69,0,0,0,2.47-1.32c1.1-1.8,2.94-3.2,6.17-3.64a.17.17,0,0,0,0-.34C164,115,149.39,118.7,147.14,124.2Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.61,136.32a7.48,7.48,0,0,0,4.71,3.32c2.59.56,3.75-1.8,2.92-4.16-.75-2.13-3-5-5.55-4.49A3.43,3.43,0,0,0,141.61,136.32Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.54,308.92c.32-40.36-8.61-79.13-8.61-79.13l33.47-.54s-3.85,58.3-5.19,82.72c-1.39,25.39-3.33,85-3.33,85l-13.59.21S152.66,340.78,154.54,308.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.21,252c9.54,13.06,5.25,37.63,1.34,55a372.88,372.88,0,0,0-4.87-57.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.59 392.28 156.45 397.51 171.77 397.26 172.66 391.72 155.59 392.28",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.36,129.59c0,.65.42,1.15.84,1.11s.73-.58.69-1.22-.42-1.14-.84-1.11S158.32,129,158.36,129.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.73,129.05c0,.65.42,1.14.84,1.11s.73-.58.69-1.22-.42-1.15-.84-1.12S165.69,128.4,165.73,129.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.25,129.54a22.8,22.8,0,0,0,3.45,5.3,3.74,3.74,0,0,1-3,.8Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.35,137.57a5.25,5.25,0,0,1-3.79-1.84.19.19,0,0,1,0-.27.19.19,0,0,1,.26,0,5.11,5.11,0,0,0,4.31,1.69.19.19,0,0,1,.2.17.19.19,0,0,1-.18.21A5.89,5.89,0,0,1,160.35,137.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.76,126.58a.64.64,0,0,1-.18-.06.39.39,0,0,1-.11-.53,3.79,3.79,0,0,1,3-1.79.38.38,0,0,1,.38.38.39.39,0,0,1-.38.38h0a3,3,0,0,0-2.35,1.44A.39.39,0,0,1,153.76,126.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.11,125.39a.38.38,0,0,1-.32-.16,3,3,0,0,0-2.42-1.28.38.38,0,1,1,0-.76,3.7,3.7,0,0,1,3.07,1.59.38.38,0,0,1-.08.53A.42.42,0,0,1,168.11,125.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.72,407.67a.18.18,0,0,1-.13-.15.18.18,0,0,1,.1-.19c.36-.2,3.56-1.88,4.54-1.36a.62.62,0,0,1,.32.5h0a1,1,0,0,1-.34.93c-.86.8-3.17.52-4.47.28Zm4.26-1.39c-.61-.2-2.34.49-3.61,1.12,1.78.27,3.1.17,3.59-.28a.69.69,0,0,0,.22-.61.22.22,0,0,0-.13-.2Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.72,407.67l-.05,0a.17.17,0,0,1-.08-.17c0-.09.19-2.26,1.19-3.11a1.42,1.42,0,0,1,1.05-.35h0c.53.05.68.31.72.52.16.91-1.73,2.68-2.69,3.13A.17.17,0,0,1,169.72,407.67Zm2.27-3.23-.19,0h0a1,1,0,0,0-.77.26,4.45,4.45,0,0,0-1,2.49c1-.61,2.26-2,2.16-2.54C172.17,404.58,172.15,404.49,172,404.44Zm-.17-.23h0Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.97 408.01 124 407.89 125.92 389.27 117.9 389.39 115.97 408.01",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.59,407l-8.75.14a.61.61,0,0,0-.62.56l-.77,7.15a1.31,1.31,0,0,0,1.32,1.41c3.15-.1,4.14-.36,8.11-.42,4.64-.07,2.5.12,7.94,0,3.29-.05,3.82-3.38,2.41-3.67-4.46-.94-5.63-2.71-7.64-4.61A2.86,2.86,0,0,0,124.59,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.92 389.27 124.93 398.87 116.9 399 117.89 389.4 125.92 389.27",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.56,307.91c4.55-36.08,2-60.24,9.93-78l28.37-.46s-14.55,57-20.09,81.08c-5.75,25-16.68,84-16.68,84l-12.94.19S120.51,337.8,126.56,307.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.76 392.28 114.58 397.51 129.02 397.26 129.86 391.72 113.76 392.28",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,407.57a.19.19,0,0,1-.17-.1.2.2,0,0,1,0-.22c.28-.31,2.7-3,3.81-2.83a.6.6,0,0,1,.47.36h0a1.08,1.08,0,0,1,0,1c-.54,1-2.8,1.57-4.1,1.79Zm3.53-2.78c-.64,0-2,1.27-3,2.29,1.76-.36,3-.9,3.27-1.49a.68.68,0,0,0,0-.65.23.23,0,0,0-.19-.14Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,407.57h0a.2.2,0,0,1-.14-.13c0-.09-.6-2.19.06-3.33a1.37,1.37,0,0,1,.86-.69h0c.51-.13.75.06.85.25.47.79-.7,3.1-1.45,3.85A.22.22,0,0,1,123,407.57Zm1-3.82-.2,0h0a1,1,0,0,0-.63.5,4.46,4.46,0,0,0-.11,2.69c.71-.91,1.44-2.65,1.17-3.12A.22.22,0,0,0,124,403.75Zm-.25-.15h0Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.32,199.56a2.49,2.49,0,0,0-.21-2.94l-1.41-1.55a.76.76,0,0,1-.12-.85,1.85,1.85,0,0,0-2.33-2.56.76.76,0,0,1-.84-.19L151,189.92a2.51,2.51,0,0,0-2.92-.48l-.42.19,4.72,5.17L157.1,200Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.61,
    y: 188.33,
    width: 28.36,
    height: 37.74,
    transform: "translate(198.27 -34.99) rotate(47.61)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.9,171.11c-2.48,4.75-5,9.63-7.42,14.46s-4.82,9.69-7,14.54c-.53,1.21-1.07,2.42-1.54,3.63l-.37.9-.09.23s0,0,0,0,0,0,0,0a3.27,3.27,0,0,0-.18-.68c-.14-.34-.39-.51-.38-.45s.14.23.44.42a11,11,0,0,0,2.64,1.19,47.84,47.84,0,0,0,7.29,1.59c1.3.19,2.61.37,3.93.53l4,.41.44,6c-1.48.32-2.87.53-4.31.72s-2.88.34-4.34.42-2.94.12-4.44.08a33,33,0,0,1-4.66-.41,19.48,19.48,0,0,1-5.17-1.48,11.79,11.79,0,0,1-3-1.9,9.33,9.33,0,0,1-2.63-3.86,9.92,9.92,0,0,1-.09-5.77l.13-.46.08-.26.34-1c.44-1.4.92-2.75,1.41-4.1,2-5.38,4.22-10.53,6.59-15.62s4.9-10,7.66-15Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.09,160.12c-7.42,2.29-15.2,22.07-15.2,22.07l16.14,9a152.22,152.22,0,0,0,8-17.55C145.82,163.43,142.06,157.34,133.09,160.12Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.16,211.68,149,209.57a5.8,5.8,0,0,0-2.33-.91l-4.68-.72a3.3,3.3,0,0,0-3.26,1.42l-1.6,2.35c-.46,4,6.68,6,6.68,6l3.67,1.74a2.82,2.82,0,0,0,3.52-.94l2-2.85A2.82,2.82,0,0,0,152.16,211.68Z",
    style: {
      fill: "#ffc3bd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pack--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 287.22,
    y1: 122.17,
    x2: 286.72,
    y2: 127.94,
    style: {
      fill: "none",
      stroke: "#3DD064",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "281.18 100.41 289.08 101.11 287.63 117.5",
    style: {
      fill: "none",
      stroke: "#3DD064",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 100.24,
    width: 79.67,
    height: 52.67,
    transform: "translate(12.02 -20.87) rotate(5.02)",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.38,
    y: 99.52,
    width: 12.17,
    height: 10.67,
    transform: "translate(10.09 -20.31) rotate(5.02)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.18,
    y: 134.96,
    width: 12.36,
    height: 10.84,
    transform: "translate(13.11 -18.15) rotate(5.02)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.9,136.57l10.9,1-.82,9.39-10.91-1,.83-9.39m-.65-.76-.94,10.79,12.31,1.09.95-10.8-12.32-1.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 265.05,
    y: 102.92,
    width: 18.5,
    height: 52.67,
    transform: "translate(12.37 -23.53) rotate(5.02)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.85 149.32 281.21 156.3 282.99 136.08 201.85 149.32",
    style: {
      opacity: 0.1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerRafiki);
export default __webpack_public_path__ + "static/media/Messenger-rafiki.c25c84392f8809a4680f41d0aef28225.svg";
export { ForwardRef as ReactComponent };